import { createTheme } from "@mui/material";

const theme = createTheme({
    palette: {
        primary: {
            main: "#145da0"
        },
        secondary: {
            main: "#0c2d48"
        }
    }
});


export default theme;